import { render, staticRenderFns } from "./person_duty.vue?vue&type=template&id=3f6969ce&scoped=true"
import script from "./person_duty.vue?vue&type=script&lang=js"
export * from "./person_duty.vue?vue&type=script&lang=js"
import style0 from "./person_duty.vue?vue&type=style&index=0&id=3f6969ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6969ce",
  null
  
)

export default component.exports